<template>
  <el-dialog title="订单操作日志" :visible.sync="dialogTableVisible" :before-close="closeDialog" width="800px" :close-on-click-modal="false">
    <el-table :data="tableData" v-loading="loading" max-height="550">
      <el-table-column prop="optCreateTime" label="操作时间" width="150"></el-table-column>
      <el-table-column prop="optUserName" label="操作人" width="120">
        <template slot-scope="scope">
          <div>{{scope.row.optUserName || scope.row.optUserId || ''}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="optDesc" label="操作详情">
        <template slot-scope="scope">
          <div v-for="(item, idx) in scope.row.optDesList" :key="idx">{{item}}</div>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>
<script>
import { getOrderLogsForRetrunPickupApi } from '@/api/waybillPrint/returnPickupPrint'
export default {
  name: "record-list",
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    rowInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      dialogTableVisible: this.isShow,
      tableData: [],
      loading: false,
    };
  },
  methods: {
    getDetailList() {
      // 获取列表
      this.loading = true;
      this.tableData = [];
      let params = {
        dayFlag: this.rowInfo.dayFlag,
        pickupOrderType: this.rowInfo.pickupOrderType,
        timeRange: this.rowInfo.timeRange,
        pickupOrderNo: this.rowInfo.pickupOrderNo,
        waybillNo: this.rowInfo.waybillNo,
        sendName: this.rowInfo.sendName,
        sendPhone: this.rowInfo.sendMobile,
        userId: 'f69314be714d4aa4b9281ddecc7aff2d'
      }
      getOrderLogsForRetrunPickupApi(params).then((res) => {
        this.loading = false;
        if (res.success && res.data) {
          this.tableData = res.data || [];
          this.tableData.forEach((item) => { 
            item.optDesList = [];
            if (item.optDesc) {
              item.optDesList = item.optDesc.split('\n');
            }
          });
          this.total = res.data.length;
        } else {
          this.tableData = [];
          this.total = 0;
        }        
      }).catch(()=>{
        this.tableData = [];
        this.total = 0;
        this.loading = false;
      });
    },
    closeDialog() {
      this.dialogTableVisible = false;
      this.$emit("closeDialog");
    },
  },
  mounted() {
    this.getDetailList();
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-pagination {
  margin-top: 20px;
  text-align: center;
}
</style>